import { ReactElement } from 'react';
import { Navigate } from 'react-router';

import { useSettings } from './SettingsProvider';

export const RequireConfigured: React.FC<{ children: ReactElement }> = ({ children }) => {
    const { configured } = useSettings();

    if (!configured) {
        return <Navigate to="/settings" replace />;
    }

    return children;
};
